import { render, staticRenderFns } from "./Facades.vue?vue&type=template&id=948f807e&lang=pug&"
import script from "./Facades.vue?vue&type=script&lang=js&"
export * from "./Facades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports